import type { AmenityFormData } from "./amenitySchema";

/**
 * Ключ содержимого начальных значений формы. Форма перезаполняется только при
 * смене ключа: страница создания передаёт новый `{}` на каждый рендер (после
 * ошибки сохранения меняется isPending), и сброс по ссылке стирал введённые
 * Category, время и дни расписания.
 */
export const getAmenityFormResetKey = (
  initialValues: Partial<AmenityFormData> | undefined,
): string | null =>
  initialValues === undefined ? null : JSON.stringify(initialValues);
